import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EmailMultiInput from './EmailMultiInput'

export default class EmailMultiInputContainer extends Component {
  render() {
    const { value = [], focus, blur } = this.props
    return (
      <EmailMultiInput
        emails={value}
        onBlur={e => {
          this.addEmail(e)
          blur()
        }}
        onFocus={focus}
        onKeyDown={e => this.handleKeyDown(e)}
        remove={email => {focus(); this.handleRemove(email)}}
      />
    )
  }
  handleRemove(email) {
    const { value = [] } = this.props
    const index = value.findIndex(e => e === email)
    this.remove(index)
  }
  remove(index) {
    const { value = [], setValue } = this.props
    if (index > -1) {
      value.splice(index, 1)
      setValue(value)
    }
  }
  handleKeyDown(event) {
    const delimiters = [' ', 'Tab', 'Enter', ',', ';']
    if (delimiters.includes(event.key)) {
      event.preventDefault()
      this.addEmail(event)
    }
    if (event.key === 'Backspace' && !event.target.value) {
      event.preventDefault()
      const { value = [] } = this.props
      this.remove(value.length - 1)
    }
  }
  addEmail(event) {
    const { value = [], setValue } = this.props
    if (event.target.value && !value.includes(event.target.value)) {
      setValue([...value, event.target.value])
      event.target.value = ''
    }
  }

  static propTypes = {
    setValue: PropTypes.func.isRequired,
    value: PropTypes.array
  }
}
